import React, { createContext, useContext, useState, ReactNode } from 'react';
import {ReactData} from "../../utils/FrontendDataTypes";
import {data as fetchBackendData} from '../../utils/datatypes'

interface DataContextType {
  data: ReactData | null;
  loading: boolean;
  error: string | null;
  refreshData: () => Promise<ReactData | null>;
}

const defaultContext: DataContextType = {
  data: null,
  loading: false,
  error: null,
  refreshData: async () => null
};

const DataContext = createContext<DataContextType>(defaultContext);

export const useData = () => useContext(DataContext);

interface DataProviderProps {
  children: ReactNode;
}

export const DataProvider: React.FC<DataProviderProps> = ({ children }) => {
  const [data, setData] = useState<ReactData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async (): Promise<ReactData | null> => {
    // Wenn bereits geladen wird, keine neue Anfrage starten
    if (loading) return data;

    try {
      setLoading(true);
      setError(null);

      console.log('DataContext: API-Aufruf gestartet');

      const d = await fetchBackendData();
      setData(d);
      console.log("data in data context:", d);
      return d

    } catch (err) {
      console.error('Fehler beim Laden der Daten:', err);
      setError('Fehler beim Laden der Daten. Bitte versuchen Sie es später erneut.');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const contextValue: DataContextType = {
    data,
    loading,
    error,
    refreshData: fetchData
  };

  return (
    <DataContext.Provider value={contextValue}>
      {children}
    </DataContext.Provider>
  );
};
